import { UserEmailNotification, Id } from 'src/types'

import api, { make, Response } from '.'

interface EmailsNotificationsResponse {
  user_email_notifications: UserEmailNotification[]
}

interface GetUserEmailNotificationsListProps {
  organization_id: Id
}

interface SaveUserEmailNotificationsProps {
  organization_id: Id
  user_email_notifications: UserEmailNotification[]
}

export function getUserEmailNotificationsList({
  organization_id
}: GetUserEmailNotificationsListProps): Promise<
  Response<EmailsNotificationsResponse>
> {
  return make<EmailsNotificationsResponse>({
    axiosCall: api.get(`organizations/${organization_id}/email/notification`)
  })
}

export function saveUserEmailNotification({
  organization_id,
  user_email_notifications
}: SaveUserEmailNotificationsProps): Promise<
  Response<EmailsNotificationsResponse>
> {
  return make<EmailsNotificationsResponse>({
    axiosCall: api.post(`organizations/${organization_id}/email/notification`, {
      user_email_notifications
    })
  })
}
